export enum eplResponse {
  GENERIC_LOGIN_FAIL = 1000,
  TEST_RECALLED = 1001,
  BEFORE_TEST_TIME = 1002,
  DEADLINE_PASSED = 1003,
  LOCKDOWN_BROWSER = 1004,
}
